import DimensionHeader from "@/components/dimension-header";
import { DimensionId } from "@/types/questionnaries";
import { useParams } from "react-router-dom";
import Summary from "./summary";
import Topics from "./topics";

const DimensionResultsPage = () => {
  const { quizId, dimensionId } = useParams();

  if (!quizId || !dimensionId) {
    throw new Error("Faltan parámetros");
  }

  return (
    <>
      <DimensionHeader
        dimensionId={dimensionId as DimensionId}
        quizId={quizId}
      />

      <Summary />

      <div className="text-xl font-semibold text-[#13171B]">Temas</div>

      <Topics />
    </>
  );
};

export default DimensionResultsPage;
